export function normalizePrice(
    price: number | { value: number } | { min: number; max: number } | { __typename?: 'SinglePrice'; value: number } | { __typename?: 'PriceRange'; min: number; max: number } | null | undefined,
):
    | { __typename?: 'SinglePrice'; value: number }
    | { __typename?: 'PriceRange'; min: number; max: number }
    | undefined {
    if (price == null) return undefined;
    if (typeof price === 'number')
        return { __typename: 'SinglePrice', value: price };
    if ('value' in price && typeof price.value === 'number')
        return { __typename: 'SinglePrice', value: price.value };
    if ('min' in price && 'max' in price)
        return { __typename: 'PriceRange', min: price.min, max: price.max };
    return undefined;
}

